import { CommonModule } from '@angular/common';
import { AfterContentInit, ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-shopping-as',
    standalone: true,
    imports: [CommonModule, TranslateModule],
    templateUrl: './shopping-as.component.html',
    styleUrl: './shopping-as.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShoppingAsComponent implements AfterContentInit {
    @Output()
    type: EventEmitter<string> = new EventEmitter<string>();
    options = [
        'business',
        'organization',
        'private',
    ];
    @Input()
    initial = 'private';

    ngAfterContentInit(): void {
        this.type.emit(this.initial);
    }

}
